import { useMutation } from "@tanstack/vue-query";

import KiliApi from "@/data/api/kili/kili-api";
import { PasswordRecoveryMutationKeys } from "@/data/api/kili/password-recovery/password-recovery-query-keys";

export function useSendPasswordRecoveryEmailMutation() {
  return useMutation({
    mutationKey: PasswordRecoveryMutationKeys.sendPasswordRecoveryEmail(),
    mutationFn: async (email: string) => {
      await KiliApi.sendPasswordRecoveryEmail(undefined, {
        params: { email },
      });
    },
  });
}
